export const BLACK = '#3C4852';
export const DARK_BLACK = '#4A5568';
export const SECONDARY = '#808080';
export const WHITE = '#fff';
export const GREEN = '#08BD80';
export const RED = '#EB5757';
export const DISABLED = '#9AAFBF';
export const BLUE = '#2D81F7';
export const ORANGE = '#FFAD3B';
export const GREY_SECONDARY = '#AAC3D9';
export const LIGHT_RED = '#EB5757';
export const LIGHTER_RED = '#FCE4E4';
export const GREY = '#DDE6ED';
export const LIGHT_GREY = '#627984';
export const LIGHTER_GREY = '#E3EBF0';
export const SKY_BLUE = '#47a7ff';
export const DEEP_BLUE = '#5d85f9';
export const VIOLET = '#8853E6';
export const LIGHT_GREEN = '#56BAC6';
export const DARK_GREY = '#8F8F8F';
export const LIGHT_BLUE = '#D5E6FD';
